<template>
    <div class="data-aicenter">
	    <div class="page-header" style="margin-bottom:15px">餐谱设置</div>
      <el-row  style="padding-left:15px;padding-right:15px;text-align:left;">
        <el-col :span="15">
          <el-row>
            <el-col :span="4">
              <div class="grid-content">营养比例：(%) </div>
            </el-col>
          </el-row>
          <el-row style="padding-left:45px">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="早餐">
                30%
              </el-form-item>
              <el-form-item label="加餐">
                5%
              </el-form-item>
              <el-form-item label="午餐">
                30%
              </el-form-item>
              <el-form-item label="午点">
                5%
              </el-form-item>
              <el-form-item label="晚餐">
                30%
              </el-form-item>
            </el-form>
          </el-row>
          <el-row>
            <el-col :span="2" style="width:60px">
              <div class="grid-content" style="line-height: 30px;">推荐搭配：</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <el-select
                    v-model="provinceId"
                    placeholder="选择地域"
                    clearable
                    @change="handProvince"
                  >
                    <el-option
                      v-for="item in provinceList"
                      clearable
                      :key="item.id"
                      :label="item.cityName"
                      :value="item.id"
                    >
                    </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top:15px" v-for="(item, index) in mealsList" :key="index">
            <el-col :span="1">
              {{item.mealsName}}
            </el-col>
            <el-col :span="23">
              <el-row>
                <el-col>
                  <div class="content-item" v-for="(group, i) in item.groupList" :key="i">
                    {{i+1}}. {{group.compositionSummary}}
                    <span class="options-group">
                      <el-link class="zuhe" @click="editComposition(group.groupId,item)">修改</el-link>
                      <el-link class="zuhe" @click="removeComposition(group.groupId)">删除</el-link>  
                    </span>  
                  </div>
                </el-col>
              </el-row>
              <el-link icon="el-icon-plus" class="zuhe" @click="addComposition(item)">添加组合</el-link>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          名词定义
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;padding-left: 15px;text-align: left;height: 50px;" v-if="iscity">
        <el-col :span="4" style="width: 73px;">
          不使用食材：
        </el-col>
        <el-col :span="6">
          <div class="list-group-item" v-for="(item, index) in notUseIngredientList" :key="index">
            <span class="list-group-content">{{item.ingredientName}}
              <span class="del" @click="remove(item.id,item.ingredientName)">
                <span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
              </span>
            </span>
          </div>
          <div>
            <el-select
              v-model="seasoning"
              style="width: 230px;"
              :remote-method="querySearchAsync"
              placeholder="搜索食材"
              clearable
              filterable
              remote
              @change="(item)=>handleSelect(item)">
              <el-option
                v-for="item in ingredientOptions"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        title="自定义餐点组合"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="60%"
        top="5vh"
        @close="closeDialog"
        destroy-on-close
        append-to-body>
        <el-row>
          <el-col style="padding-left: 10px;color:rgb(51, 51, 51)">
            <span style="font-weight:500">{{mealsName}}：</span>
            <span style="font-size:12px">{{mealsSummary}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-table
              :data="tableData"
              :header-cell-style="{color:'#333',fontSize:'14px',fontWeight:900}"
              :row-style="{fontSize:'12px',color:'#333'}"
              style="width: 100%">
              <el-table-column
                label="大类"
                width="110">
                <template slot-scope="scope">
                  <svg-icon :style="{'color':'#27B1A2'}" :icon-class="scope.row.icon"></svg-icon>
                  <span style="margin-left: 10px">{{ scope.row.cateName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="数量"
                width="90">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.quantity" placeholder="请选择" @change="(val)=>handleQuantityChange(val,scope.row.smallCateList)">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="小类">
                <template slot="header" slot-scope="scope">
                小类<span style="font-size:12px;color:gray;display:inline-block;margin-left:10px;">将在选择的小类间循环使用</span>
                </template>
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.smallCateList" :key="index" class="smallCate">
                    {{item.cateName}}
                    <el-switch
                      :disabled="item.smallDisabled"
                      v-model="item.checked"
                      active-color="#13ce66"
                      inactive-color="#DCDFE6"
                      @change="(nval)=>changeCate(nval,scope.row)">
                    </el-switch>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="6" style="padding-top: 36px">
            <div style="padding-left: 55px;border-top: 1px solid #EBEEF5;">
              <h3>名词定义</h3>
              <span style="font-size:12px">
                煎炸类：包括油条、油饼、菜饺、生煎、锅贴、芝麻球等<br><br>
                小熟食：含香肠、火腿、鸡柳、炸丸子等<br>
              </span>
            </div>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { fetchCityList } from '@/api/city'
import { queryByKeyWord } from '@/api/catering/ingredient'
import { fetchDishesCateList,fetchCompositionList,fetchCompositionGroup,saveCompositionGroup,deleteMealsSetGroup,saveNotUseIngredient,queryNotUseIngredientList,removeNotUseIngredient } from '@/api/aicenter'
export default {
  data(){
    return {
      seasoning: null,
      states: null,
      dialogVisible: false,
      mealsName: null,
      mealsValue: null,
      groupId: null,
      provinceId: null,
      provinceList: [],
      tableData: [],
      mealsList:[],
      mealsGroup:[],
      ingredientOptions: [],
      options:[
        {value: 0},
        {value: 1},
        {value: 2},
        {value: 3}
      ],
      notUseIngredientList:[],
      iscity: false
    }
  },
  computed:{
    mealsSummary: function() {
      if(this.tableData.length > 0) {
        let summary = "";
        this.tableData.map(item=>{
          let childSummary = "";
          item.smallCateList.map(cate=>{
            if(cate.checked) {
              childSummary += cate.cateName + "/";
            }
          })
          if(childSummary) {
            childSummary = childSummary.substring(0,childSummary.length-1);
            summary += item.cateName +""+item.quantity+"(" + childSummary + ")+";
          }
        })
        summary = summary.substring(0,summary.length-1);
        return summary;
      }
    }
  },
  created() {
    this.getCityList(0);
  },
  methods: {
    getCityList(parentId) {
      fetchCityList(parentId).then(response=>{
        this.provinceList = response.data;
      })
    },
    queryNotUseIngredientList(id) {
      queryNotUseIngredientList(id).then(response=>{
        this.notUseIngredientList = response.data;
      })
    },
    loadComposition(id) {
      fetchCompositionList(id).then(response=>{
        this.mealsList = response.data;
        this.iscity = true;
        this.queryNotUseIngredientList(id);
      })
    },
    handProvince(id) {
      this.loadComposition(id);
    },
    addComposition(meals) {
      if(!this.provinceId) {
        this.$message.error("请先选择推荐搭配的地域");
        return;
      }
      this.dialogVisible = true;
      this.mealsGroup = [];
      this.tableData = [];
      this.groupId = null;
      this.mealsName = meals.mealsName;
      this.mealsValue = meals.mealsValue;
      this.dishesCateList();
    },
    editComposition(groupId,item) {
      this.dialogVisible = true;
      this.mealsValue = item.mealsValue;
      this.tableData = [];
      this.mealsName = item.mealsName;
      this.groupId = groupId;
      fetchCompositionGroup({groupId:groupId}).then(response=>{
        const data = response.data;
        if(data && data.length > 0) {
          this.mealsGroup = data;
        }
        this.dishesCateList();
      })
    },
    dishesCateList() {
      fetchDishesCateList().then(response=>{
        let data = response.data;
        if(this.mealsGroup.length > 0) {
          data.map(item=>{
            let cateList = item.smallCateList;
            cateList.map(cate=>{
              this.mealsGroup.map(group=>{
                if(cate.id == group.cateId) {
                  cate.checked = true;
                }
              })
            })
            this.mealsGroup.map(group=>{
              if(item.id == group.cateId) {
                item.quantity = group.quantity;
                item.smallCateList.forEach(s=>{
                  s.smallDisabled = false;
                })
              }
            })
          })
        }
        this.tableData = data
      })
    },
    handleQuantityChange(val,smallCateList) {
      if(val > 0) {
        smallCateList.forEach(cate=>{
          cate.smallDisabled = false;
        })
      } else {
        smallCateList.forEach(cate=>{
          cate.checked = false;
          cate.smallDisabled = true;
        })
      }
    },
    closeDialog() {
      this.tableData = [];
    },
    changeCate(nval,item) {
      console.log(item)
    },
    handleDialogConfirm() {
      if(!this.mealsSummary) {
        this.$message.warning("请先选择餐点组合")
        return;
      }
      let mealsModel = {
        mealsValue: this.mealsValue,
        groupId: this.groupId,
        areaId: this.provinceId,
        dishesCate: this.tableData
      }
      saveCompositionGroup(mealsModel).then(response=>{
        this.$message.success("餐点组合保存成功");
        this.dialogVisible = false;
        this.handProvince(this.provinceId);
      })
    },
    removeComposition(groupId) {
      this.$confirm('是否要删除该餐点组合? 删除后某些功能将不可用', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteMealsSetGroup(groupId).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.handProvince(this.provinceId);
          });
        });
    },
    querySearchAsync(queryString, cb) {
      if(queryString) {
        queryByKeyWord({keyWord:queryString}).then(response=>{
          let result = response.data.map(item=>{
            return {value: item.commonName,id:item.id}
          })
          // cb(result)
          this.ingredientOptions = result;
        })
      }
    },
    handleSelect(val) {
      if(val) {
        let smallObj = this.ingredientOptions.filter(item=>{
          return item.id == val;
        })
        let item = smallObj[0];
        let ingredient = {areaId: this.provinceId,ingredientName: item.value,ingredientId:item.id};
        this.states = '';
        saveNotUseIngredient(ingredient).then(response=>{
          this.$message.success("不使用食材设定成功");
          this.queryNotUseIngredientList(this.provinceId);
          this.ingredientOptions = [];
        })
      }
    },
    remove(id,name) {
      this.$confirm('是否要删除排行食材【'+name+'】', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeNotUseIngredient(id).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryNotUseIngredientList(this.provinceId);
          });
        });
    },
	}
}
</script>

<style lang="scss">
.content-item {
  display: block;
  margin-bottom: 20px;
  &:hover {
    .options-group {
      display: inline-block;
      padding-left: 25px;
    }
  }
}
.options-group {
  display: none;
}
.smallCate {
    display: inline-block;
    margin-right: 10px;
    margin-top:5px;
    width: 100px;
    text-align: right;
}
.el-dialog__body {
    padding: 0px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.list-group-item {
	font-size: 12px;
	height: 25px;
	margin-bottom: 2px;
	line-height: 25px;
   &:hover .list-group-content{
      background-color:rgb(225, 225, 225);
      .del {
        display: inline-block;
        height: 20px;
        width: 20px;
        position: absolute;
        right: -35px;
        cursor: pointer;
        span {
          display:inline-block;
        }
      }
    }
}

.list-group-content {
	padding-left: 10px;
  background-color: #fafafa;
  display: inline-block;
  width: 230px;
  position: relative;
  .del span{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aicenter/components/foodMenu/index.vue